import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next) 
//   .use(LanguageDetector) 
  .init({
    fallbackLng: 'en',
    debug: true,
    resources: {
      en: {
        translation: require('./locale/en/translation.json')
      },
      da: {
        translation: require('./locale/dk/translation.json')
      },
    },
    interpolation: {
      escapeValue: false, 
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
 